//这个文件是全局 ws
// import store from '@/store' //引入状态管理   //引入状态管理
class WebSocketClass {
  /**
   * @description: 初始化实例属性，保存参数
   * @param {String} url ws的接口
   * @param {Function} msgCallback 服务器信息的回调传数据给函数
   */
  constructor(url, msgCallback) {
    this.url = url;
    this.msgCallback = msgCallback;
    this.websockCountClose = 6; // ws 重连次数上限
    this.ws = null;  // websocket对象
  }
  /**
   * @description: 初始化 连接websocket或重连webSocket时调用
   * @param {*} 可选值 要传的数据
   */
  connect() {
    this.ws = new WebSocket(this.url);
    this.ws.onopen = () => {
      // 连接ws成功回调
      // console.log(`连接成功`, e)
      return this.sendHandle();
    };
    // 监听服务器端返回的信息
    this.ws.onmessage = e => {
      // console.log('服务器返回消息', e)
      // 把数据传给回调函数，并执行回调
      const redata = JSON.parse(e.data);
      //登陆失败重新登陆
      if (redata.msg === 'error' && redata.action === 'login') {
        if (this.websockLoginCount !== 0) {
          this.websockLoginCount -= 1;
          this.sendHandle();
        } else {
          this.closeMyself();
        }
        return;
      }
      if (redata.action === 'error') return;
      return this.msgCallback(redata);
    };
    // ws关闭回调
    this.ws.onclose = () => {
      // console.log('关闭回调模式', e, this.ws.readyState)
      this.closeMyself();
    };
    // ws出错回调
    this.onerror = () => {
      // console.log('ws出错', e);
      if (this.websockCountClose !== 0) {
        this.websockCountClose -= 1;
        this.connect();
      } else {
        this.closeMyself();
      }
    }
  }
  // 发送信息给服务器
  sendHandle() {
    // console.log(`发送消息给服务器:`);
    let accesstoken = JSON.parse(localStorage.getItem('user'));
    let actions = {action:"login",accesstoken:accesstoken?accesstoken.accesstoken:null};
    return this.ws.send(JSON.stringify(actions));
  }
  // 手动关闭WebSocket
  closeMyself() {
    // console.log(`关闭`)
    return this.ws.close();
  }
}
// function someFn() {
//   // console.log('接收服务器消息的回调：', data);
//   store.commit('upNewsCount', true);
// }
// let host = window.location.host.indexOf("localhost") != -1 ? 'edu.topeti.com' : window.location.host
// // 消息铃铛实时监听
// let wsUri = "wss://"+host+'/message'
// console.log("wsUri===",wsUri)
// const wsValue = new WebSocketClass(wsUri, someFn); // 阮一峰老师教程链接
// wsValue.connect('立即与服务器通信'); // 连接服务器

// h5签名
const webSocketClass = new WebSocketClass();
export default webSocketClass;
